var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [
          _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-top-center" },
            [
              _c("md-progress-spinner", {
                attrs: {
                  "md-diameter": 50,
                  "md-stroke": 5,
                  "md-mode": "indeterminate"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.project
      ? _c(
          "div",
          { staticClass: "md-layout md-gutter md-alignment-top-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "\n        md-layout-item\n        md-size-15\n        md-medium-size-10\n        md-small-size-10\n        md-xsmall-size-0\n      "
              },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-fab",
                    on: {
                      click: function($event) {
                        return _vm.goBack()
                      }
                    }
                  },
                  [_c("md-icon", [_vm._v("arrow_back")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "\n        md-layout-item\n        md-size-75\n        md-medium-size-70\n        md-small-size-100\n        md-xsmall-size-100\n      "
              },
              [
                _c(
                  "md-card",
                  { staticStyle: { width: "100%" } },
                  [
                    _c("md-card-header", [
                      _c("div", { staticClass: "md-title" }, [
                        _vm._v(_vm._s(_vm.project.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("md-card-content", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "md-layout md-gutter md-alignment-top-center"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "md-layout-item md-size-50" },
                            [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.project.description)
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "md-layout-item md-size-50" },
                            [
                              _vm.project.imageLink != "undefined"
                                ? _c("img", {
                                    attrs: {
                                      src:
                                        "/static/uploads/" +
                                        _vm.project.imageLink
                                    },
                                    on: { error: _vm.setAltImg }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("h3", [_vm._v(_vm._s(_vm.project.company))]),
                              _vm._v(" "),
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.project.companyDescription
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("h3", [_vm._v("Ansprechpartner")]),
                              _vm._v(" "),
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.project.responsible)
                                }
                              })
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "md-layout md-gutter md-alignment-top-center"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "md-layout-item md-size-70" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout md-gutter md-alignment-top-center"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "md-layout-item md-size-50"
                                    },
                                    [
                                      _c("h4", [
                                        _vm._v("Verwendete Technologien")
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.project.appliedTechnologies,
                                        function(tech) {
                                          return _c(
                                            "div",
                                            { key: tech.hash },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: {
                                                      name: "TechnologyDetail",
                                                      params: {
                                                        hash: tech.hash
                                                      }
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "md-chip",
                                                    {
                                                      staticClass: "md-primary",
                                                      staticStyle: {
                                                        margin: "2px"
                                                      },
                                                      attrs: {
                                                        "md-clickable": ""
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(tech.name))]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.project.appliedTechnologies.length ==
                                      0
                                        ? _c("div", [
                                            _c("h5", [_vm._v("Keine")])
                                          ])
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "md-layout-item md-size-50"
                                    },
                                    [
                                      _c("h4", [
                                        _vm._v("Geschäftsmodellaspekte")
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.project.involvedBma, function(
                                        bma
                                      ) {
                                        return _c(
                                          "div",
                                          { key: bma.hash },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to: {
                                                    name: "BusinessModelDetail",
                                                    params: { hash: bma.hash }
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "md-chip",
                                                  {
                                                    staticClass: "md-primary",
                                                    staticStyle: {
                                                      margin: "2px"
                                                    },
                                                    attrs: {
                                                      "md-clickable": ""
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(bma.name))]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      _vm._v(" "),
                                      _vm.project.involvedBma.length == 0
                                        ? _c("div", [
                                            _c("h5", [_vm._v("Keine")])
                                          ])
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "md-layout-item md-size-30" },
                            [
                              _c("h4", [_vm._v("Tags")]),
                              _vm._v(" "),
                              _vm._l(_vm.project.tags, function(tag) {
                                return _c(
                                  "div",
                                  { key: tag.hash },
                                  [
                                    _c(
                                      "md-chip",
                                      {
                                        staticClass: "md-secondary",
                                        staticStyle: { margin: "2px" }
                                      },
                                      [_vm._v(_vm._s(tag.name))]
                                    )
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _vm.project.tags.length == 0
                                ? _c("div", [_c("h5", [_vm._v("Keine")])])
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "\n        md-layout-item\n        md-size-10\n        md-medium-size-20\n        md-small-size-20\n        md-xsmall-size-40\n      "
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a690c46a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a690c46a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/referenceprojectsearch/detail/ReferenceProjectDetail.vue
// module id = null
// module chunks = 